import(/* webpackMode: "eager", webpackExports: ["CookieBanner"] */ "/home/runner/work/oxpa.pro/oxpa.pro/packages/shared/src/components/cookie-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LddGlobalCatcher"] */ "/home/runner/work/oxpa.pro/oxpa.pro/packages/shared/src/components/ldd-global-catcher.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ErrorHandlerProvider"] */ "/home/runner/work/oxpa.pro/oxpa.pro/packages/shared/src/providers/error-handler-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["NativePluginsProvider"] */ "/home/runner/work/oxpa.pro/oxpa.pro/packages/shared/src/providers/native-plugins-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SupabaseProvider"] */ "/home/runner/work/oxpa.pro/oxpa.pro/packages/shared/src/providers/supabase-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemeProvider"] */ "/home/runner/work/oxpa.pro/oxpa.pro/packages/shared/src/providers/theme-provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MetrikaConsent"] */ "/home/runner/work/oxpa.pro/oxpa.pro/src/app/_components/metrika-consent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["YandexMetrikaGoals"] */ "/home/runner/work/oxpa.pro/oxpa.pro/src/app/_components/yandex-metrika-goals.tsx");
;
import(/* webpackMode: "eager" */ "/home/runner/work/oxpa.pro/oxpa.pro/src/app/globals.css");
